import { render } from "./DefSlideRight.vue?vue&type=template&id=10823d94&scoped=true"
import script from "./DefSlideRight.vue?vue&type=script&lang=js"
export * from "./DefSlideRight.vue?vue&type=script&lang=js"

import "./DefSlideRight.vue?vue&type=style&index=0&id=10823d94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10823d94"]])

export default __exports__